<template>
  <b-modal @close="close" :active.sync="isCategoryModalActive" :width="640" scroll="keep">
    <form>
      <div class="modal-card" style="width: auto;">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $t("categoryModal.titleModalEdit") }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-field :label="$t('category.name')">
            <b-input
              type="text"
              v-model="category.name"
              :placeholder="$t('category.name')"
              required
            >
            </b-input>
          </b-field>

          <b-field :label="$t('form.incomeExpense')">
            <b-switch
              v-model="category.type"
              true-value="income"
              false-value="expense"
            >
              {{ category.type }}
            </b-switch>
          </b-field>
        </section>
        <footer class="modal-card-foot" :class="{'multiple' : isEdit}">
          <b-button
            v-if="isEdit"
            class="button is-danger"
            @click="deleteCategory"
            >{{ $t("button.delete") }}</b-button
          >
          <b-button
            class="button is-primary"
            @click="validateBeforeAddCategory"
            v-if="!isEdit"
            >{{ $t("button.add") }}</b-button
          >
          <b-button
            class="button is-primary"
            @click="validateBeforeEditCategory"
            v-if="isEdit"
            >{{ $t("button.edit") }}</b-button
          >
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
const defaultCategory = {
  name: "",
  type: "expense"
};

import firebase from "firebase/app";
import toast from "@/mixins/toast";
import { mapGetters } from "vuex";

export default {
  mixins: [toast],
  name: "CategoryModal",
  props: {
    isCategoryModalActive: {
      type: Boolean
    },
    categoryToEdit: {
      type: Object
    }
  },
  data() {
    return {
      category: { ...defaultCategory },
      originalCategory: {}
    };
  },
  methods: {
    addCategory() {
      let categoryToAdd = { ...this.category };
      this.$store.dispatch("categories/addCategory", {
        categoryToAdd,
        type: this.category.type
      }).then(this.close);
    },
    deleteCategory() {
      this.$store
        .dispatch("categories/deleteCategory", this.category)
        .then(this.close);
    },
    editCategory() {
      this.$store
        .dispatch("categories/editCategory", {
          categoryToEdit: this.category,
          originalCategory: this.originalCategory
        })
        .then(this.close);
    },
    validCategory() {
      return this.category.name;
    },
    validateBeforeAddCategory() {
      if (this.validCategory()) {
        this.addCategory();
      } else {
        this.showInvalidFormMessage();
      }
    },
    validateBeforeEditCategory() {
      if (this.validCategory()) {
        this.editCategory();
      } else {
        this.showInvalidFormMessage();
      }
    },
    close() {
      this.$emit("close");
    },
    showValidCategoryAdded() {
      this.showErrorToast("Category added");
    },
    showValidCategoryDeleted() {
      this.showSuccessToast("Category deleted");
    },
    showInvalidCategoryAdded() {
      this.showErrorToast("Could not add category");
    },
    showValidCategoryEdit() {
      this.showSuccessToast("Category editted");
    },
    showInvalidFormMessage() {
      this.showErrorToast("Please fill in all the fields.");
    }
  },
  computed: {
    isEdit() {
      return this.categoryToEdit ? true : false;
    }
  },
  watch: {
    categoryToEdit(value) {
      this.originalCategory = { ...value };
      this.category = { ...value };
    }
  }
};
</script>
